import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";
import { AuthProvider, useAuth } from "../contexts/AuthProvider";
import ButtonWithLoading from "../components/UiElements/ButtonWithLoading";
import Logo from "../assets/img/logo-blue.png";
import PatooLogo from "../assets/img/patoo/logo.png";
import PatooIcon from "../assets/img/patoo/patoo-icon.png";
import Amenita from "../assets/img/amenita.png";

const { REACT_APP_CLIENT_URL } = process.env;

const AuthHeader = ({ userRef }: { userRef: string }) => {
  return (
    <div className="flex justify-center items-center text-center">
      <img src={Logo} alt="Naya logo" className="w-[140px] mt-10" />
      {userRef === "withpatoo" && (
        <img
          src={PatooLogo}
          alt="Patoo logo"
          className="w-[140px] mt-10 ml-6"
        />
      )}
    </div>
  );
};

const SocialLogin = () => {
  const { signInWithGoogle } = useAuth();
  return (
    <div className="flex justify-center flex-col text-center">
      <button
        onClick={() => signInWithGoogle()}
        className="w-full md:w-2/3 flex justify-center items-center bg-white rounded-lg shadow-md p-1 hover:bg-gray-light m-auto z-1"
      >
        <img src="data:image/png;base64,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" />
      </button>
      <span className="text-sm pt-1 text-center">Google</span>
    </div>
  );
};

export const VerifyOtp = ({
  email,
  signLoading,
}: {
  email: string;
  signLoading: boolean;
}) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { getUser } = useAuth();
  const [otpCode, setOtpCode] = useState<string[]>(Array(6).fill(""));
  const [isVerified, setIsVerified] = useState<boolean>(true);
  const inputRefs = useRef<(HTMLInputElement | null)[]>(Array(6).fill(null));

  const handleOtpChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const { value } = event.target;

    if (/^[0-9]$/.test(value)) {
      const newOtpCode = [...otpCode];
      newOtpCode[index] = value;
      setOtpCode(newOtpCode);

      // Move focus to the next input on input
      if (index < 5 && inputRefs.current[index + 1]) {
        inputRefs.current[index + 1]?.focus();
      }
    } else if (value === "") {
      // Handle delete/backspace key
      const newOtpCode = [...otpCode];
      newOtpCode[index] = "";
      setOtpCode(newOtpCode);

      // Move focus to the previous input on delete/backspace
      if (index > 0 && inputRefs.current[index - 1]) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const handleKeyDown = (
    event: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (event.key === "ArrowLeft" && index > 0) {
      // Move focus to the previous input on left arrow key
      inputRefs.current[index - 1]?.focus();
    } else if (event.key === "ArrowRight" && index < 5) {
      // Move focus to the next input on right arrow key
      inputRefs.current[index + 1]?.focus();
    } else if (event.key === "Delete" && otpCode[index] === "" && index > 0) {
      // Handle delete key for empty input
      const newOtpCode = [...otpCode];
      newOtpCode[index - 1] = ""; // Clear the previous input
      setOtpCode(newOtpCode);
      inputRefs.current[index - 1]?.focus(); // Move focus to the previous input
    }
  };

  const handleVerify = async () => {
    window.analytics.page("enters_pin_code_page");
    setLoading(true);
    setIsVerified(true);
    const enteredOtp = otpCode.join("");
    // Simulate verification logic (replace with your actual logic)
    const { data, error } = await supabase.auth.verifyOtp({
      email,
      token: enteredOtp,
      type: "email",
    });
    if (error) {
      console.log(error);
      setIsVerified(false);
      setLoading(false);
      return;
    }
    const user = await getUser();
    setLoading(false);
    navigate("/journal");
    window.analytics.track("completes_auth");
  };

  const handlePaste = (
    event: React.ClipboardEvent<HTMLInputElement>,
    index: number
  ) => {
    const pastedData = event.clipboardData.getData("text/plain");

    if (/^\d+$/.test(pastedData) && pastedData.length <= 6) {
      const newOtpCode = Array(6).fill("");
      pastedData.split("").forEach((char, i) => {
        newOtpCode[i] = char;
      });
      setOtpCode(newOtpCode);
    }
  };

  const reSend = async () => {
    setLoading(true);
    setOtpCode(Array(6).fill(""));
    setIsVerified(true);
    const { data, error } = await supabase.auth.signInWithOtp({ email });
    setLoading(false);
  };

  return (
    <div>
      <p className="text-eastern-blue text-xl mb-10">
        I’ve just sent you an email with a code
        <br />
        <b>Please enter it below</b>
      </p>
      <div className="w-1/4 justify-center mx-auto">
        <div className="flex justify-center gap-2 mb-4">
          {otpCode.map((value, index) => (
            <input
              onKeyDown={(event) => handleKeyDown(event, index)}
              onPaste={(event) => handlePaste(event, index)}
              key={index}
              type="text"
              value={value}
              onChange={(event) => handleOtpChange(event, index)}
              className="border px-3 py-3 rounded-lg text-center w-12 h-12"
              maxLength={1}
              ref={(el) => (inputRefs.current[index] = el)}
            />
          ))}
        </div>
        <ButtonWithLoading
          loading={loading}
          onClick={() => handleVerify()}
          buttonText="Verify"
        />
      </div>
      {otpCode.join("").length === 6 && !isVerified && (
        <p className="text-red-500 mt-2">
          Incorrect OTP code, click Resend to try again
        </p>
      )}
      <div className="pt-10 text-gray">
        <p>Didn't get it?</p>
        <ButtonWithLoading
          type="text"
          loading={signLoading}
          buttonText="Resend"
          onClick={() => reSend()}
        />
      </div>
    </div>
  );
};

export default function Auth() {
  const [authMethod, setAuthMethod] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);
  const [data, setData] = useState({
    email: "",
    newsletter: true,
    ref: "",
  });

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const email = urlParams.get("email") ?? "";
    const ref = urlParams.get("ref") ?? "";
    setData({ ...data, email, ref: ref });
  }, []);

  const isEmailValid = (email: string) => {
    const regex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    return email.match(regex);
  };

  const sign = async () => {
    setLoading(true);
    setErrorMsg(null);
    const { email, newsletter } = data;

    if (!isEmailValid(email)) {
      setLoading(false);
      return setErrorMsg("Invalid email address");
    }
    try {
      setLoading(true);
      const { data: signOtpData, error } = await supabase.auth.signInWithOtp({
        email,
        options: {
          emailRedirectTo: `${REACT_APP_CLIENT_URL}/journal`,
          data: {
            ref: data.ref,
          },
        },
      });

      if (error) throw error;
      setSuccess(true);
    } catch (error: any) {
      setSuccess(false);
      setLoading(false);
      setErrorMsg(
        "Oops! It seems there's a hiccup with signing in at the moment. Please feel free to try again later. If the issue persists, don't hesitate to reach out to our support team for assistance. We appreciate your patience!"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthProvider>
      <main className="bg-cream relative overflow-hidden min-h-screen mx-auto">
        <AuthHeader userRef={data.ref} />
        <div className="relative container mx-auto mt-0 px-8 md:px-0 md:mt-10 text-center">
          {!success ? (
            <div>
              <div className="mb-8">
                <p className="text-eastern-blue text-xl mb-2">
                  Welcome to Naya 👋
                </p>
              </div>
              <div className="flex flex-col justify-center w-full lg:w-3/4 gap-5 m-auto items-center">
                <div className="flex flex-col w-full md:w-1/3 justify-center gap-2">
                  <input
                    type="email"
                    placeholder="Email Address"
                    onChange={(v) =>
                      setData({ ...data, email: v.target.value })
                    }
                    value={data.email}
                    className="w-full border-0 px-4 py-[10px] text-[16px] md:py-[10px] rounded-l-md bg-white drop-shadow-xl mb-4"
                  />
                  <ButtonWithLoading
                    onClick={() => sign()}
                    loading={loading}
                    buttonText="Continue"
                  />
                  {errorMsg && <p className="text-red text-sm">*{errorMsg}</p>}
                </div>
                {!data.ref?.length && (
                  <>
                    <div className="flex items-center pt-4 w-1/2 m-auto">
                      <div className="flex-grow h-px bg-eastern-blue"></div>
                      <span className="flex-shrink text-eastern-blue px-4 italic font-light">
                        Or continue with
                      </span>
                      <div className="flex-grow h-px bg-eastern-blue"></div>
                    </div>
                    <SocialLogin />
                  </>
                )}
                <label className="w-full flex items-center text-sm justify-center">
                  <input
                    type="checkbox"
                    checked={data.newsletter}
                    onChange={(v) =>
                      setData({ ...data, newsletter: v.target.checked })
                    }
                    className="mr-2 w-[15px] h-[15px]"
                  />
                  Sign me up to the Naya’s newsletter
                </label>
                <div className="flex justify-center md:flex-start">
                  <p className="text-[10px] text-[#585757] uppercase pt-4 md:pt-0 w-[90%] md:w-2/3 font-bold tracking-widest	">
                    By continuing, you agree to NAYA’S{" "}
                    <a href="/terms" target="_blank">
                      Terms & Conditions
                    </a>{" "}
                    and{" "}
                    <a href="/privacy-policy" target="_blank">
                      Privacy Policy
                    </a>
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <VerifyOtp email={data.email} signLoading={loading} />
          )}
        </div>

        {data.ref === "withpatoo" ? (
          <img src={PatooIcon} alt="amenita" className="mt-10 m-auto" />
        ) : (
          <img src={Amenita} alt="amenita" className="mt-10 m-auto" />
        )}
      </main>
    </AuthProvider>
  );
}
